import { Integration } from "@/interfaces/integrations/Integration"
import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { useBot } from "./useBot"
import { IntegrationProviderEnum } from "@/enums/integrations/IntegrationProviderEnum"

const axios = useAxios()

export interface SaveIntegrationDTO {
  provider: IntegrationProviderEnum
  data: any
  enabled?: boolean
}

export function useIntegration() {
  const { selectedBot } = useBot()

  const save = async (payload: SaveIntegrationDTO): Promise<void> => {
    await axios.put(`/bots/${selectedBot.value?.id}/integrations`, { ...payload })
  }

  const getByProvider = async (provider: IntegrationProviderEnum): Promise<Integration> => {
    const response = await axios.get(`/bots/${selectedBot.value?.id}/integrations`, { params: { provider } })

    return response.data
  }

  return {
    save,
    getByProvider
  }
}